<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title" />
  </div>
</template>

<script>
import '../static/service.js';

export default {
  name: 'App'
};
</script>

<style>
/* 引入字体 */
@import './assets/fonts/font.css';

.questions-container .el-carousel__button {
  margin: 0 10px;
  width: 16px !important;
  height: 16px !important;
  border-radius: 8px !important;
  background-color: transparent;
  border: 2px solid rgba(255, 255, 255, 0.5019607843137255);
}

.questions-container .el-carousel__indicator.is-active button {
  background-color: rgba(255, 156, 60, 1);
  opacity: 1;
  border: 1px solid rgba(255, 156, 60, 1);
}

</style>



// WEBPACK FOOTER //
// src/App.vue